import React from 'react';
import {
  Text,
  List,
  ListItem,
  CTA,
  styled,
  TextTag,
  TokenTextAppearance,
  Breakpoints,
} from '@volkswagen-onehub/components-core';
import ResultGallery from './ResultGallery';
import ResultBuild from './ResultBuild';
import { ResultModel } from '../../types/results';
import { useFeatureServices } from '../../use-feature-services';
import { ContainerMain } from '../../styles/global.style';

const ResultModelContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => props.theme.size.dynamic0140};
  padding-bottom: ${(props) => props.theme.size.dynamic0270};
`;

const ResultDetailsContainer = styled(ContainerMain)`
  flex-direction: column;

  @media screen and (min-width: ${Breakpoints.b960}px) {
    flex-direction: row;
    padding-right: 0;
  }
`;

const ResultDescriptionContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.dynamic0100};
  justify-content: center;
  padding: ${(props) => props.theme.size.dynamic0150};
  padding-left: ${(props) => props.theme.size.grid001};
  padding-right: ${(props) => props.theme.size.grid001};

  @media screen and (min-width: ${Breakpoints.b960}px) {
    padding: ${(props) => props.theme.size.dynamic0150};
    padding-left: 0;
    padding-right: 0;
  }
`;

const GalleryContainer = styled.div`
  flex: 1;
  margin-left: calc(-1 * ${(props) => props.theme.size.grid001});
  margin-right: calc(-1 * ${(props) => props.theme.size.grid001});

  @media screen and (min-width: ${Breakpoints.b960}px) {
    align-self: center;
    margin-left: 0;
    margin-right: 0;
  }
`;

const ResultTitleContainer = styled.div``;

const ResultBodyContainer = styled.div``;

const HighlightContainer = styled.div``;

interface ResultModelInterface {
  result: ResultModel;
}

const ResultModel: React.FC<ResultModelInterface> = ({result}) => {
  const { tracking } = useFeatureServices();

  const handleLearnClick = (e: React.SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    tracking.track('VWBasic_Link_Click', {
      eventInfo: {
        contentId: result.carlineName,
        brand: "passenger"
      },
      configuration: {
        CarlineName: result.carlineName
      },
      process: {
        Name: 'SUVW Questionnaire and Lead Capture Form',
        StepName: 'Results',
      },
      link: {
        url: result.cta.learn.url,
        name: result.cta.learn.linkName
      }
    });

    window.open(result.cta.learn.url, '_self');
  };

  return (
    <ResultModelContainer>
      <ResultDetailsContainer>
        <ResultDescriptionContainer>
          <ResultTitleContainer>
            <Text
              tag={TextTag.h3}
              appearance={TokenTextAppearance.headline300}
              bold
            >
              {result.title}
            </Text>

            <Text tag={TextTag.h3} appearance={TokenTextAppearance.headline300}>
              {result.subTitle}
            </Text>
          </ResultTitleContainer>

          <ResultBodyContainer>
            <Text tag={TextTag.p}>{result.descriptions}</Text>
          </ResultBodyContainer>

          <HighlightContainer>
            <List>
              {result.highlights.map((highlight, index) => (
                <ListItem key={'highlight' + index}>{highlight}</ListItem>
              ))}
            </List>
          </HighlightContainer>

          <CTA
            tag="a"
            emphasis="tertiary"
            href={result.cta.learn.url}
            aria-label={result.cta.learn.title}
            onClick={handleLearnClick}
          >
            {result.cta.learn.title}
          </CTA>
        </ResultDescriptionContainer>

        <GalleryContainer>
          <ResultGallery images={result.images} />
        </GalleryContainer>
      </ResultDetailsContainer>

      <ResultBuild result={result} />
    </ResultModelContainer>
  );
};

export default ResultModel;